import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase/config';

const AuthRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <div>Loading...</div>; // TODO: Make this look nicer! Maybe add a cool spinner? 🌀
  }

  if (!user) {
    return <Navigate to="/" />; // No sneaking in! Back to login you go 😉
  }

  return children;
};

export default AuthRoute; 